import React from 'react';
import { useQuizContext } from '../../../../context/QuizContext';
import { MultipleChoiceData } from '../../../../types/quiz';
import { P } from '@osmosis/react-ui/components/Text';
import AnswerChoice from '../../AnswerChoice';
import { QuizContainer } from '../../QuizContainer';

/**
 * Https://elsevier.atlassian.net/browse/OSMS-680.
 */
const MultipleCheckbox = () => {
  const { currentItem } = useQuizContext();
  return (
    <QuizContainer>
      <P
        fontSize={16}
        color="gray50"
        fontWeight={400}
        textAlign="justify"
        dangerouslySetInnerHTML={{
          __html: (currentItem?.data as MultipleChoiceData).question,
        }}
      />

      <AnswerChoice />
    </QuizContainer>
  );
};

export default MultipleCheckbox;
